import React from 'react';
import './styles/Carregando.css';

class Carregando extends React.Component {
  render() {
    return (
      <div className="carregandoPai">
        <div className="carregando">
          <h1>Carregando...</h1>
        </div>
      </div>
    );
  }
}

export default Carregando;
